import { render, staticRenderFns } from "./MySwipes.vue?vue&type=template&id=6343453d&"
import script from "./MySwipes.vue?vue&type=script&lang=js&"
export * from "./MySwipes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports